import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { PersonDetails } from './inquiry/inquiry'

interface ReleaseNotes {
  IsArchived: boolean
  ItemCreated?: Date
  ItemCreatedBy?: PersonDetails | string
  'ItemCreatedBy/edipi'?: string
  'ItemCreatedBy/email'?: string
  'ItemCreatedBy/firstname'?: string
  'ItemCreatedBy/lastname'?: string
  ItemModified: Date
  ItemModifiedBy: PersonDetails | string
  'ItemModifiedBy/edipi'?: string
  'ItemModifiedBy/email'?: string
  'ItemModifiedBy/firstname'?: string
  'ItemModifiedBy/latname'?: string
  KnownIssues: string
  NewFeatures: string
  ResolvedIssues: string
  VersionName: string
  eKey?: string
  eTag?: string
}
interface ReleaseNoteArgs {
  isArchived?: boolean
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  ETag: 'eTag',
  Ekey: 'eKey',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  KnownIssues: 'KnownIssues',
  NewFeatures: 'NewFeatures',
  ResolvedIssues: 'ResolvedIssues',
  VersionName: 'VersionName',
}
const LIST_NAME = 'ReleaseNotesList'

const getReleaseNoteback = async (args?: ReleaseNoteArgs): Promise<ReleaseNotes[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = args?.isArchived === false ? `IsArchived eq ${Boolean(false)}` : ''
  const orderBy = args?.orderBy ?? COLUMN_NAMES.ItemCreated
  const ascending = args?.isAscending ?? false
  const items = await list
    .query()
    .filter(filter)
    .select(...Object.values(COLUMN_NAMES))
    .expand(COLUMN_NAMES.ItemCreatedBy, COLUMN_NAMES.ItemModifiedBy)
    .orderBy([{ ascending, orderBy }])
    .get()
  return [...items] as ReleaseNotes[]
}
const addOrUpdateReleaseNote = async (addObj: ReleaseNotes): Promise<ReleaseNotes | undefined> => {
  try {
    const releaseNoteList = await mpfRListsHttp().getList(LIST_NAME)
    return await releaseNoteList.addOrUpdateItem(addObj)
  } catch (error) {
    console.error('Error in addOrUpdateReleaseNote:', error)
    throw error
  }
}

export {
  COLUMN_NAMES,
  LIST_NAME,
  type ReleaseNoteArgs,
  type ReleaseNotes,
  addOrUpdateReleaseNote,
  getReleaseNoteback,
}
